// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1YahX","content":"styles_content__2CdbG","selectAll":"styles_selectAll__mxL3l"};